"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTextAreaWrapper = exports.StyledTextAreaHelperText = exports.StyledTextArea = exports.getVariantColor = void 0;
const theme_1 = require("@icr-ui/theme");
const utils_1 = require("@icr-ui/utils");
const styled_components_1 = __importStar(require("styled-components"));
const flexbox_1 = require("../flexbox");
const getVariantColor = (messageType) => {
    switch (messageType) {
        case 'error':
            return theme_1.system.error;
        case 'warning':
            return theme_1.system.warning;
        default:
            return theme_1.grayScale[600];
    }
};
exports.getVariantColor = getVariantColor;
exports.StyledTextArea = styled_components_1.default.textarea `
  ${({ messageType, customStyles, value, isValueFilled }) => (0, styled_components_1.css) `
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    caret-color: ${theme_1.palette.primary.main};
    background-color: ${isValueFilled ? '#faffe2' : 'white'};
    width: 100%;
    max-width: 100%;
    min-height: 109px;
    border: 0;
    border-bottom: 2px solid ${(0, exports.getVariantColor)(messageType)};
    color: ${!!value && !messageType
    ? theme_1.palette.grayScale[900]
    : (0, exports.getVariantColor)(messageType)};
    font-size: ${theme_1.fonts.body.normal.fontSize};
    font-weight: ${theme_1.fonts.body.weights.medium};
    line-height: ${theme_1.fonts.body.normal.lineHeight};
    transition: all 0.2s;

    ${customStyles || {}}

    ::placeholder {
      color: ${!messageType ? theme_1.palette.grayScale[600] : (0, exports.getVariantColor)(messageType)};
    }

    &:disabled {
      color: ${theme_1.grayScale[400]};
      border-bottom: 2px solid ${theme_1.palette.grayScale[400]};
      cursor: not-allowed;
      user-select: none;
      pointer-events: none;
      background-color: transparent;
      &::placeholder {
        color: ${theme_1.grayScale[400]};
      }
      &:hover {
        border-bottom: 2px solid ${theme_1.grayScale[400]};
      }
    }

    &:active,
    &:target,
    &:focus {
      border-bottom: 2px solid ${theme_1.palette.primary.light};
      color: ${theme_1.grayScale[900]};

      &::placeholder {
        color: ${theme_1.grayScale[900]};
      }
    }
    &:hover {
      border-bottom: 2px solid ${theme_1.primary.main};
    }

    @media print {
      display: none;
    }
  `}
`;
exports.StyledTextAreaHelperText = (0, styled_components_1.default)(flexbox_1.Flexbox) `
  ${({ messageType = 'info', helperText }) => (0, styled_components_1.css) `
    width: 100%;
    height: 20px;
    transition: all 0.2s ease-in-out;

    color: ${!messageType ? theme_1.grayScale[600] : (0, exports.getVariantColor)(messageType)};
    ${helperText
    ? (0, styled_components_1.css) `
          opacity: 1;
          visibility: visible;
        `
    : (0, styled_components_1.css) `
          opacity: 0;
          visibility: hidden;
        `};
  `}
`;
exports.StyledTextAreaWrapper = (0, styled_components_1.default)(flexbox_1.Flexbox) `
  height: auto;
  position: relative;
  padding: 4px;
  transition: all 0.2s;

  &:focus-within:focus-visible {
    ${exports.StyledTextArea} {
      border: 0;
    }
    ${exports.StyledTextAreaHelperText} {
      display: none;
    }
    border-radius: 4px;
    box-shadow: ${theme_1.shadows.containedFocus(theme_1.primary.dark, theme_1.primary.dark)};
    ${(0, utils_1.getFocusStyles)(theme_1.primary.dark)}
  }
`;
//# sourceMappingURL=styles.js.map